import { useState } from 'react';

interface ExclusiveSessionProps {
  onRegister: () => void;
  onBookMeeting: () => void;
}

export default function ExclusiveSession({ onRegister, onBookMeeting }: ExclusiveSessionProps) {
  const [calendarAdded, setCalendarAdded] = useState(false);

  const handleAddToCalendar = () => {
    const event = {
      title: 'Covasant Session: Scaling AI Apps & Agents from Pilot to Production',
      description: 'Join Adi Mopidevi, Chief Product Officer at Covasant, for an exclusive session on operationalizing agentic AI and scaling securely with governance.',
      location: 'Atlantis, The Palm, Dubai - Cluster A · Track 1',
      startDate: '2026-02-12T12:05:00',
      endDate: '2026-02-12T12:20:00'
    };

    const googleCalendarUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(event.title)}&details=${encodeURIComponent(event.description)}&location=${encodeURIComponent(event.location)}&dates=${event.startDate.replace(/[-:]/g, '').replace('T', 'T')}/${event.endDate.replace(/[-:]/g, '').replace('T', 'T')}`;
    
    window.open(googleCalendarUrl, '_blank');
    setCalendarAdded(true);
  };

  return (
    <section className="py-10 bg-gradient-to-r from-[#0f172a] via-[#1e293b] to-[#0f172a] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-6 lg:gap-10">
          {/* Speaker Image */}
          <div className="flex-shrink-0">
            <div className="w-20 h-20 rounded-xl overflow-hidden border-2 border-[#3b82f6]/40">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Indian%20male%20technology%20executive%20in%20his%2040s%20wearing%20elegant%20dark%20suit%20with%20subtle%20pattern%20neutral%20gray%20background%20corporate%20portrait%20photography%20confident%20visionary%20expression%20warm%20lighting&width=400&height=400&seq=speaker-adi-1&orientation=squarish"
                alt="Adi Mopidevi"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Session Info */}
          <div className="flex-1 text-center lg:text-left">
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 mb-2">
              <span className="inline-flex items-center gap-1.5 bg-[#3b82f6]/20 text-[#3b82f6] px-3 py-1 rounded-full text-xs font-semibold">
                <i className="ri-star-fill text-[10px]"></i>
                Exclusive Session
              </span>
              <span className="text-white/50 text-xs">Feb 12, 2026 · 12:05 PM GST · Cluster A</span>
            </div>
            <h3 className="text-lg md:text-xl font-bold text-white mb-1">
              Scaling AI Apps & Agents from <span className="text-[#3b82f6]">Pilot to Production</span>
            </h3>
            <p className="text-white/60 text-sm">
              <span className="text-white font-medium">Adi Mopidevi</span>, Chief Product Officer · Former Microsoft Leader
            </p>
          </div>

          {/* CTAs */}
          <div className="flex flex-wrap items-center justify-center gap-3 flex-shrink-0">
            <button
              onClick={handleAddToCalendar}
              className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-lg text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                calendarAdded 
                  ? 'bg-[#1e3a8a] text-white' 
                  : 'bg-[#1e3a8a] hover:bg-[#1e40af] text-white'
              }`}
            >
              <i className={calendarAdded ? 'ri-check-line' : 'ri-calendar-check-line'}></i>
              {calendarAdded ? 'Added' : 'Add to Calendar'}
            </button>
            <button
              onClick={onRegister}
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-white hover:bg-gray-100 text-gray-900 rounded-lg text-sm font-semibold transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-user-add-line"></i>
              Register
            </button>
            <button
              onClick={onBookMeeting}
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-white/10 hover:bg-white/20 border border-white/20 text-white rounded-lg text-sm font-semibold transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-todo-line"></i>
              Book 1:1
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
